import type { WorkspaceGraphAnchor } from '../../services/kpWorkspaceService';

function clampUnit(value: number) {
  return Math.min(1, Math.max(0, value));
}

export function resolveStoredImageAnchorPosition(
  anchor: WorkspaceGraphAnchor | undefined,
  index: number,
  total: number,
) {
  if (anchor?.kind === 'image_point' && anchor.x != null && anchor.y != null) {
    return {
      x: clampUnit(anchor.x),
      y: clampUnit(anchor.y),
    };
  }

  if (anchor?.kind === 'image_point' && anchor.source !== 'fallback') {
    return {
      x: clampUnit(anchor.x ?? 0.98),
      y: clampUnit(anchor.y ?? 0.5),
    };
  }

  const fallbackDenominator = Math.max(total + 1, 2);
  return {
    x: 0.98,
    y: clampUnit((index + 1) / fallbackDenominator),
  };
}

export function resolveImageAnchorPosition(
  anchor: WorkspaceGraphAnchor | undefined,
  index: number,
  total: number,
) {
  const position = resolveStoredImageAnchorPosition(anchor, index, total);
  return {
    x: position.x,
    y: clampUnit(1 - position.y),
  };
}
